import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-full-name-input',
  standalone: false,
  templateUrl: './full-name-input.component.html',
  styleUrl: './full-name-input.component.scss'
})
export class FullNameInputComponent {
  @Input() value: string = '';
  @Input() hasError: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.valueChange.emit(this.value);
  }
}
